module.exports = Promise.all([__parcel__import__("7GVoP"), __parcel__import__("6nQdU")]).then(() => parcelRequire('g36Vt'));